import "./ProtectedFilesView.scss";

import {ButtonPanel} from "../common/ButtonPanel";
import React, {ReactNode} from "react";
import HttpsIcon from '@mui/icons-material/Https';
import {PreferenceActions} from "../../redux/PreferencesSlice";
import AppsIcon from "@mui/icons-material/Apps";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ListIcon from "@mui/icons-material/List";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {ProtectedFileControls} from "./ProtectedFileControls";
import classNames from "classnames";
import {AttachmentFilesView} from "../attachments/AttachmentFilesView";
import {ProtectedFileListView} from "./ProtectedFileListView";
import {FolderLocation} from "../../locations/FolderLocation";
import {AttachmentFolderId, PhotosFolderId, ProtectedFilesFolderId} from "../../reducers/FolderReducer";
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import {PhotosBrowserView} from "../photos/PhotosBrowserView";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import {PhotoBreadcrumbs} from "../photos/PhotoBreadcrumbs";

export const FilesView = () => {
    const dispatch = useAppDispatch();

    const selectedFolderId = useAppSelector(s => s.folderState.selectedFolderId);

    const isMobile = useAppSelector(({system}) => system.isMobile);

    const viewMode = useAppSelector(s => s.preferenceState.viewMode);

    const {controlsElt, viewElt, showViewMode} = getViewElements(selectedFolderId);

    const buttons = (
        <>
            <ToggleButtonGroup exclusive={true}
                               value={selectedFolderId}
                               onChange={(_, value) => value && FolderLocation.selectFolderById(value)}>
                <ToggleButton value={ProtectedFilesFolderId} title="Protected Files">
                    <HttpsIcon/>
                </ToggleButton>
                <ToggleButton value={AttachmentFolderId} title="Attachments">
                    <AttachFileIcon/>
                </ToggleButton>
                <ToggleButton value={PhotosFolderId} title="Photos">
                    <PhotoLibraryIcon/>
                </ToggleButton>
            </ToggleButtonGroup>

            {showViewMode &&
                (<ToggleButtonGroup exclusive={true}
                                    value={viewMode}
                                    onChange={(_, value) => dispatch(PreferenceActions.changeViewMode(value))}>
                    <ToggleButton value="icons" title="Icons View">
                        <AppsIcon/>
                    </ToggleButton>
                    <ToggleButton value="list" title="List View">
                        <ListIcon/>
                    </ToggleButton>
                </ToggleButtonGroup>)}

            {controlsElt}

            <div className="filler">&nbsp;</div>
        </>
    );
    return (
        <ButtonPanel className={classNames("files-container", viewMode)}
                     buttonsClassName="files-buttons"
                     buttonLocation="top"
                     buttons={buttons}
                     fillContent={isMobile}>
            {viewElt}
        </ButtonPanel>
    );
}

function getViewElements(selectedFolderId: number | undefined): { controlsElt: ReactNode, viewElt: ReactNode, showViewMode: boolean } {
    switch (selectedFolderId) {
        case ProtectedFilesFolderId:
            return {controlsElt: <ProtectedFileControls/>, viewElt: <ProtectedFileListView/>, showViewMode: true};
        case AttachmentFolderId:
            return {controlsElt: null, viewElt: <AttachmentFilesView/>, showViewMode: true};
        case PhotosFolderId:
            return {controlsElt: <PhotoBreadcrumbs/>, viewElt: <PhotosBrowserView/>, showViewMode: false};
    }
    return {
        controlsElt: <div>No controls defined</div>,
        viewElt: <div>No view defined</div>,
        showViewMode: false
    };
}